import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const listComponents = async (
  companyId: string,
  companyType: string,
  projectId: number
) =>
  post("projectService/component/listComponents", {
    company_id: companyId,
    company_type: companyType,
    project_id: projectId,
  });

export const createComponent = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/component/createComponent", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const updateComponent = async (
  companyId: string,
  companyType: string,
  id: number,
  payload: Record<string, any>
) =>
  post("projectService/component/updateComponent", {
    company_id: companyId,
    company_type: companyType,
    id,
    ...payload,
  });

export const deleteComponent = async (
  companyId: string,
  companyType: string,
  id: number
) =>
  post("projectService/component/deleteComponent", {
    company_id: companyId,
    company_type: companyType,
    id,
  });
